<template>
  <div class="">
    <transition
      enter-active-class="duration-500 ease-out transform"
      enter-class="translate-y-full opacity-0"
      enter-to-class="translate-y-0 opacity-1"
      leave-active-class="duration-500 ease-in transform"
      leave-class="translate-y-0 opacity-1 "
      leave-to-class="translate-y-full opacity-0">
      <div v-if="activeTab"  class="relative z-30 pb-4 -mb-4 bg-gray-900 bg-opacity-50 rounded-t-2xl">
        <div class="flex flex-col flex-1 h-full py-6" >
          <component :is="activeTab.component" v-bind:state="state" v-on:change="$emit('change', $event)" v-on:close="onClose" />
        </div>
      </div>
    </transition>


    <div class="relative z-40 rounded-t-lg md:rounded-t-2xl">
      <div class="pb-4 -mb-4 bg-gray-800 rounded-t-lg md:rounded-t-2xl">
        <nav
          class="flex justify-between max-w-xl p-4 mx-auto align-center"
          aria-label="Tabs">
          <template v-for="tab in tabs">
            <button
              @click.prevent="activate(tab)"
              type="button"
              class="inline-flex items-center p-2 sm:p-4 text-white rounded-full shadow-sm bg-gradient-to-r hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              :class="[ activeTabId === tab.id
                  ? 'from-purple-400 via-pink-500 to-red-500 hover:to-purple-400 hover:via-pink-500 hover:from-red-500'
                  : 'from-purple-400 to-purple-500 hover:from-purple-400 hover:via-pink-500 hover:to-red-500']">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  :d="tab.iconSvgPath"/>
              </svg>
            </button>
          </template>
        </nav>
      </div>
      <CaptureButton v-bind:gallery="gallery" v-bind:state="state" v-on:capture="$emit('capture')" v-on:view-gallery="$emit('view-gallery')"/>
    </div>
  </div>
</template>

<script>
const SceneControls = () => import("./SceneControls");
const LightingControls = () => import("./LightingControls");
const PropControls = () => import("./PropControls");
const CameraControls = () => import("./CameraControls");
const EffectControls = () => import("./EffectControls");
const VideoControls = () => import("./VideoControls");
const DebugControls = () => import("./DebugControls");
const CaptureButton = () => import("./CaptureButton");

const testVar = "one";

export default {
  props: {
    state: {
      type: Object,
      default: null,
    },
    gallery: {
      type: Array,
      default: () => []
    }
  },

  components: {
    CaptureButton,
  },
  data() {
    return {
      activeTab: null,
      showDebug: true,
      tabAnimateTimout: null,
      tabAnimateTimeoutDelay: 500,

      tabs: [
        // {
        //   default: true,
        //   title: 'Debug',
        //   iconSvgPath: 'M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4',
        //   id: 'debug',
        //   component: DebugControls,
        // },
        {
          default: true,
          title: "Video",
          iconSvgPath:
            "M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z",
          id: "video",
          component: VideoControls,
        },
        {
          title: "Scene",
          iconSvgPath:
            "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z",
          id: "scene",
          component: SceneControls,
        },
        {
          title: "Lighting",
          iconSvgPath:
            "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z",
          id: "lights",
          component: LightingControls,
        },
        {
          title: "Props",
          iconSvgPath:
            "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4",
          id: "objects",
          component: PropControls,
        },
        {
          title: "Camera",
          iconSvgPath:
            "M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z",
          id: "camera",
          component: CameraControls,
        },
        {
          title: "Special",
          iconSvgPath:
            "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z",
          id: "special",
          component: EffectControls,
        },
      ],
    };
  },

  mounted() {
    let defaultTab = this.tabs.find((el) => el.default === true);
    if (defaultTab !== undefined) this.activeTab = defaultTab;
  },

  computed: {
    activeTabId() {
      if (this.activeTab !== null) return this.activeTab.id;
      return null;
    },
  },

  methods: {

    onClose () {
      this.activeTab = null
    },

    activate(tab) {
      if(this.activeTab === null) this.activeTab = tab
      else if (this.activeTab !== tab) {
        this.onClose()

        clearTimeout(this.tabAnimateTimeout)
        this.tabAnimateTimeout = setTimeout(() => {
          this.activeTab = tab
        }, this.tabAnimateTimeoutDelay)
      }
      else {
        this.activeTab = null
      }
    },
  },
};
</script>
